// Campaign-related constants and configurations

export const SLIDE_DURATION = 4000; // ms

export const GRADIENTS = {
  primary: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)',
  success: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
  rainbow: 'linear-gradient(45deg, #dc2626, #ef4444, #f87171, #fca5a5)',
  warning: 'linear-gradient(135deg, #f87171 0%, #dc2626 100%)',
  complete: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
};

export const STATUS_COLORS = {
  Draft: { bg: '#fed7d7', color: '#c53030' },
  Launched: { bg: '#fbb6ce', color: '#b83280' },
  Completed: { bg: '#c6f6d5', color: '#2d7d32' },
  Approved: { bg: '#c6f6d5', color: '#2d7d32' },
  Pending: { bg: '#fef5e7', color: '#d69e2e' },
  Dropped: { bg: '#fed7d7', color: '#c53030' },
};

export const THEME_COLORS = {
  primary: '#dc2626',
  primaryDark: '#991b1b',
  success: '#16a34a',
  successDark: '#15803d',
  lightRed: '#f87171',
  lightestRed: '#fca5a5',
  white: '#ffffff',
  grey: '#666',
  lightGrey: '#ccc',
};

export const CAROUSEL_CONFIG = {
  height: 400, // Fixed height for carousel
  autoPlayDuration: SLIDE_DURATION,
};

export const COMPLETE_CAMPAIGN_STEPS = [
  'Finalize all creator payments',
  'Lock campaign data from further editing',
  'Generate final campaign report',
  'Mark campaign as completed',
];